module.exports = __webpack_public_path__ + "img/permit3x.2fba6037.png";